<script>
    import TableStatus from './table.status.svelte'

    export let title = ''
    export let meta = ''
    export let statusValue = ''
    export let statusVariant = null
</script>

<article class="details-card">
    {#if title || meta || statusValue || $$slots.right}
        <header class="details-card__header">
            <div class="details-card__heading">
                {#if title}
                    <h2 class="details-card__title">{title}</h2>
                {/if}
                {#if meta}
                    <p class="details-card__meta">{meta}</p>
                {/if}
            </div>
            {#if $$slots.right || statusValue}
                <div class="details-card__aside">
                    <slot name="right">
                        {#if statusValue}
                            <TableStatus label={statusValue} variant={statusVariant} />
                        {/if}
                    </slot>
                </div>
            {/if}
        </header>
    {/if}

    <div class="details-card__body">
        <slot />
    </div>

    {#if $$slots.footer}
        <footer class="details-card__footer">
            <slot name="footer" />
        </footer>
    {/if}
</article>
